import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Skeleton } from '../../components/ui/skeleton';
import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';

const SYMBOLS = { GBP: '\u00a3', EUR: '\u20ac', USD: '$', CAD: 'CA$', AUD: 'A$' };

export default function CurrenciesAdmin() {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => adminAPI.getCurrencies().then(r => { setCurrencies(r.data || []); setLoading(false); }).catch(() => toast.error('Failed to load currencies'));
  useEffect(() => { load(); }, []);

  const toggle = async (code, field, value) => {
    try {
      await adminAPI.updateCurrency(code, { [field]: value });
      toast.success(`${code} updated`);
      load();
    } catch { toast.error('Failed to update currency'); }
  };

  return (
    <div className="space-y-5" data-testid="admin-currencies-page">
      <div>
        <h2 className="text-xl font-bold" style={{ fontFamily: 'var(--font-display)', color: 'hsl(var(--c4p-navy-900))' }}>Currency Management</h2>
        <p className="text-sm mt-0.5" style={{ color: 'hsl(var(--muted-fg))' }}>Enable or disable currencies. All prices are set manually - no live FX conversion.</p>
      </div>
      <div className="rounded-xl border bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow style={{ background: 'hsl(var(--muted))' }}>
              <TableHead>Currency</TableHead>
              <TableHead>Symbol</TableHead>
              <TableHead>Default</TableHead>
              <TableHead>Active</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? Array.from({ length: 4 }).map((_, i) => (
              <TableRow key={i}><TableCell colSpan={4}><Skeleton className="h-8 w-full" /></TableCell></TableRow>
            )) : currencies.map(c => (
              <TableRow key={c.code} className="data-table-row">
                <TableCell>
                  <div className="font-medium">{c.code}</div>
                  <div className="text-xs" style={{ color: 'hsl(var(--muted-fg))' }}>{c.name}</div>
                </TableCell>
                <TableCell>{SYMBOLS[c.code] || c.symbol}</TableCell>
                <TableCell>
                  {c.is_default
                    ? <Badge variant="outline" className="text-xs">Default</Badge>
                    : <Button variant="ghost" size="sm" className="text-xs h-6" onClick={() => toggle(c.code, 'is_default', true)}>Set Default</Button>
                  }
                </TableCell>
                <TableCell>
                  <button
                    onClick={() => toggle(c.code, 'is_active', !c.is_active)}
                    className="relative inline-flex h-5 w-9 items-center rounded-full transition-colors"
                    style={{ background: c.is_active ? 'hsl(var(--c4p-navy-900))' : 'hsl(var(--border))' }}
                    data-testid={`currency-toggle-${c.code}`}
                  >
                    <span className="inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform"
                      style={{ transform: c.is_active ? 'translateX(18px)' : 'translateX(2px)' }} />
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
